<template>
    <auth-card-template :large="true">
        <card-auth>
            <div class="text-center mb-6">
                <h4 class="font-family-title font-weight-bold text-success mb-4">
                    Migre os seus sites gratuitamente!
                </h4>
            </div>

            <div v-show="isFormSent">
                <div v-show="!isRegistered" class="text-center">
                    <p class="text-lg">
                        <span class="d-inline-block mb-3">
                            Agora, para continuar com a sua solicitação, clique no link abaixo
                            para concluir o cadastro em nossa plataforma:
                        </span>
                    </p>

                    <router-link
                        class="text-lg font-weight-semibold"
                        :to="{ path: '/auth/register', query: { email: formData.email, name: formData.name }}"
                    >
                        Cadastre-se na Hostoo
                    </router-link>
                </div>

                <div v-show="isRegistered" class="text-center">
                    <p class="text-lg">
                        <span class="d-inline-block mb-3">
                            Sua solicitação foi recebida!<br>
                            Agora você pode acessar a nossa plataforma e continuar utilizando os seus serviços
                            clicando no link abaixo:
                        </span>
                    </p>

                    <router-link
                        class="text-lg font-weight-semibold"
                        :to="{ path: '/auth/login', query: { email: formData.email }}"
                    >
                        Fazer login
                    </router-link>
                </div>
            </div>

            <form v-if="!isFormSent" @submit.prevent="$_recaptcha_verify(requestMigration)">
                <form-group label="E-mail" label-for="migrationEmail" :error="formErrors.email">
                    <input
                        type="email"
                        id="migrationEmail"
                        class="form-control"
                        autocomplete="email"
                        spellcheck="false"
                        autofocus
                        v-model="formData.email"
                        v-input-lowercase
                    />
                </form-group>

                <form-group label="Nome completo" label-for="migrationName" :error="formErrors.name">
                    <input
                        type="text"
                        id="migrationName"
                        class="form-control"
                        autocomplete="name"
                        v-model="formData.name"
                    />
                </form-group>

                <form-group label="Celular" label-for="migrationPhone" :error="formErrors.phone">
                    <the-mask
                        type="tel"
                        id="migrationPhone"
                        class="form-control"
                        autocomplete="tel-national"
                        placeholder="(00) 00000-0000"
                        autofocus
                        :mask="['(##) ####-####', '(##) #####-####']"
                        v-model="formData.phone"
                    />
                </form-group>

                <form-group label="Domínios" label-for="migrationDomains" :error="formErrors.domains">
                    <textarea
                        class="form-control"
                        rows="2"
                        placeholder="Informe os domínios que deseja migrar para a Hostoo..."
                        spellcheck="false"
                        v-model="formData.domains">
                    </textarea>
                </form-group>

                <form-group label="Dados de acesso" label-for="migrationExtra" :error="formErrors.extra">
                    <textarea
                        class="form-control"
                        rows="5"
                        placeholder="Informe aqui dados de acesso ao painel de sua hospedagem, acessos FTP, SSH, bancos de dados, contas de e-mail e outros que considerar relevante para a migração..."
                        spellcheck="false"
                        v-model="formData.extra">
                    </textarea>
                </form-group>

                <div class="mt-6">
                    <button-form ref="btnMigration" type="submit" theme="success" class="btn-lg btn-block">Solicitar migração</button-form>
                </div>

                <vue-recaptcha
                    v-if="recaptchaKey"
                    ref="recaptcha"
                    size="invisible"
                    :sitekey="recaptchaKey"
                    :loadRecaptchaScript="true"
                    @verify="$_recaptcha_onVerified"
                    @expired="$_recaptcha_onExpired"
                />

                <div class="mb-6"></div>
            </form>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import ButtonForm       from '@/components/atoms/ButtonForm'
    import FormGroup        from '@/components/molecules/FormGroup'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'
    import recaptcha        from '@/mixins/recaptcha'
    import ErrorService     from '@/services/ErrorService'
    import VueRecaptcha     from 'vue-recaptcha'

    export default {
        mixins: [
            recaptcha
        ],
        components: {
            ButtonForm,
            FormGroup,
            CardAuth,
            AuthCardTemplate,
            VueRecaptcha,
        },
        data() {
            return {
                formData: {},
                formErrors: {},
                isFormSent: false,
                isRegistered: false,
                recaptchaKey: '',
            }
        },
        created()
        {
            // reCAPTCHA
            this.recaptchaKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
        },
        methods: {
            /**
             * Registrar solicitação de migração.
             */
            requestMigration()
            {
                this.formErrors = {};
                this.$refs.btnMigration.loadingFocus();

                let postData = Object.assign({ captcha: this.$_recaptcha_token }, this.formData);

                this.$api.post('/migration', postData)
                    .then (response => {
                        this.isRegistered = response.data.data.isRegistered;
                        this.isFormSent = true;
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnMigration.setLoading(false);
                        this.$refs.recaptcha.reset();
                    });
            },
        }
    }
</script>
